/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Provider_NameInputs */

const en_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Powered by Mistral`)
};

const de_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Powered by Mistral`)
};

const fr_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Alimenté par Mistral`)
};

const es_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Impulsado por Mistral`)
};

const it_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI — Powered by Mistral`)
};

const nl_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Aangedreven door Mistral`)
};

const pl_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Zasilane przez Mistral`)
};

const fi_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI — Powered by Mistral`)
};

const da_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI — Drives af Mistral`)
};

const sv_settings_ai_provider_name = /** @type {(inputs: Settings_Ai_Provider_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema AI -- Drivs av Mistral`)
};

/**
* | output |
* | --- |
* | "Alchema AI -- Powered by Mistral" |
*
* @param {Settings_Ai_Provider_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_provider_name = /** @type {((inputs?: Settings_Ai_Provider_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Provider_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_provider_name(inputs)
	if (locale === "fr") return fr_settings_ai_provider_name(inputs)
	if (locale === "es") return es_settings_ai_provider_name(inputs)
	if (locale === "it") return it_settings_ai_provider_name(inputs)
	if (locale === "nl") return nl_settings_ai_provider_name(inputs)
	if (locale === "pl") return pl_settings_ai_provider_name(inputs)
	if (locale === "fi") return fi_settings_ai_provider_name(inputs)
	if (locale === "da") return da_settings_ai_provider_name(inputs)
	if (locale === "sv") return sv_settings_ai_provider_name(inputs)
	return en_settings_ai_provider_name(inputs)
});